// extracted by mini-css-extract-plugin
export default {"box1":"Test_box1__Bb9bT","box2":"Test_box2__sE+o5","wrapper":"Test_wrapper__iDnuC","box":"Test_box__Vk5Tu"};